const PHASES = [
    { n: "01", t: "Introducción", d: "Establecer autoridad en el primer minuto." },
    { n: "02", t: "Conocimiento", d: "Escuchar al cliente más de lo que se le habla." },
    { n: "03", t: "Argumentación", d: "Hablar de valor con las palabras del cliente." },
    { n: "04", t: "Rebatir", d: "Usar la información del cliente, no defender la nuestra." },
];

export default function Method() {
    return (
        <section
            id="metodo"
            data-testid="method-section"
            className="bg-white py-28 md:py-40"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-12">
                <div className="max-w-[920px]">
                    <h2 className="font-serif-display italic text-4xl md:text-6xl tracking-tight text-[#1A1A1A] leading-[1.05]">
                        Smart Sales Systems™
                    </h2>
                    <p className="mt-5 font-serif-display italic text-lg md:text-2xl text-[#666666]">
                        Más de una década de venta high-ticket destilada en una metodología propia.
                    </p>

                    <div className="mt-10 space-y-6 text-base md:text-lg text-[#1A1A1A] leading-[1.75]">
                        <p>
                            Smart Sales Systems™ no es una herramienta. Es la columna vertebral de
                            cada sistema que desplegamos. Un protocolo que define cómo se cualifica
                            un lead, cómo se conduce una conversación, cómo se argumenta valor sin
                            perder posición, y cómo se cierra sin perseguir.
                        </p>
                        <p>
                            El método tiene cuatro fases. Si saltas una, te quemas en la siguiente.
                        </p>
                    </div>
                </div>

                <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-4 gap-px bg-[#E5E0D5] border border-[#E5E0D5]">
                    {PHASES.map((p, i) => (
                        <div
                            key={p.n}
                            data-testid={`phase-${i}`}
                            className="bg-white p-8 md:p-10 relative"
                        >
                            <p className="font-serif-display text-4xl md:text-5xl text-[#8B6914] leading-none">
                                {p.n}.
                            </p>
                            <h3 className="font-serif-display text-2xl md:text-3xl text-[#1A1A1A] mt-5">
                                {p.t}
                            </h3>
                            <p className="mt-4 text-sm md:text-base text-[#666666] leading-[1.7]">
                                {p.d}
                            </p>
                        </div>
                    ))}
                </div>

                <p className="mt-16 font-serif-display italic text-base md:text-lg text-[#1A1A1A] max-w-[760px]">
                    El método se ejecuta en cada despliegue. La tecnología es la herramienta. El
                    método es el producto.
                </p>
            </div>
        </section>
    );
}
